<template>
  <div class="crystal">
    <p>En vous approchant vous découvrez les symboles apparus :</p>
    <img src="../../assets/Gipsy/symboles.png" class="symboles" />
    <p>
      Cela ne semble pas avoir de sens ! Vous demandez à Carmen des explications mais
      sa bouche comme ses paupières restent closes. Soudain, elle s'écrie d'une voix semblant
      venir d'outre-tombe :
    </p>
    <p class="citation">
      Mauritanie, Samoa, Laos, Ghana, Indonésie, Burkina Faso...
      <br />...tel est le chemin à suivre pour avancer, c'est capital de chez capital !
    </p>
    <p>
      La tension retombe dans la pièce. Carmen semble épuisée. Vous notez
      immédiatement sur votre carnet ses dernières paroles ainsi que les drôles de symbole et la remerciez pour son aide. Vous
      reprenez l'image et laissez votre voisine se reposer. Vous avez suffisamment de matière
      pour progresser de votre côté. Il n'est pas certain que vous vous endormiez facilement ce
      soir !
    </p>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >🕯 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>
<script>
import Hint from "../Gipsy/Hint";

export default {
  name: "Crystal",
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "dayTwo")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.crystal {
  padding: 5% 10%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 90%;
}
.citation {
  font-family: "Great Vibes", cursive;
  text-align: center;
  font-weight: bolder;
  font-size: 24px;
  margin-top: 8%;
  margin-bottom: 8%;
}
.symboles {
  width: 100%;
  margin-top: 5%;
  margin-bottom: 5%;
}
.hints {
  margin-bottom: 3%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>